/**
 * Cálculos de preview del carrito — Portal Cliente Menuee
 *
 * Responsabilidad: subtotal de ítems para UI (ADR-019).
 *
 * Qué nunca debe hacer:
 * - Persistir ni devolver total oficial, delivery definitivo, propinas ni descuentos.
 * - Escribir montos en el estado del carrito.
 */

/**
 * @typedef {import('../hooks/useCarrito').CarritoItem} CarritoItem
 */

/**
 * Monto preview de una línea: precio unitario × cantidad.
 *
 * @param {CarritoItem} item
 * @returns {number}
 */
export function calcularLineaPreview(item) {
  const precio = Number(item?.precio);
  const cantidad = Number(item?.cantidad);
  const precioSeguro = Number.isFinite(precio) ? precio : 0;
  const cantidadSegura = Number.isFinite(cantidad) && cantidad > 0 ? cantidad : 1;
  const extrasTotal = (item?.extras || []).reduce(
    (acc, extra) =>
      acc + (Number.isFinite(Number(extra?.precio)) ? Number(extra.precio) : 0),
    0
  );
  return (precioSeguro + extrasTotal) * cantidadSegura;
}

/**
 * Subtotal preview del carrito (suma de líneas, sin delivery).
 *
 * @param {CarritoItem[]} items
 * @returns {number}
 */
export function calcularSubtotalPreview(items) {
  return (items || []).reduce((acc, item) => acc + calcularLineaPreview(item), 0);
}
